export enum ScheduleRepetitionType {
  NO_REPETITION = 'NO_REPETITION',
  DAILY = 'DAILY',
  WEEKLY_ON_DAY = 'WEEKLY_ON_DAY',
  WEEKLY_ON_DATE = 'WEEKLY_ON_DATE',
  MONTHLY_FIRST_DAY = 'MONTHLY_FIRST_DAY',
  MONTHLY_LAST_DAY = 'MONTHLY_LAST_DAY',
  ANUALLY_ON_DATE = 'ANUALLY_ON_DATE',
}
